import { createContext } from '@shared/utils/createContext';

type CatalogCategorySectionContext = { id: string; title: string; publicUrlPath: string };
const [CatalogCategorySectionProvider, useContext] = createContext<CatalogCategorySectionContext | undefined>({
  strict: false,
  name: 'CatalogCategorySection',
});

/**
 * A hook to access the nearest <CatalogCategorySectionProvider />.
 *
 * @param strict Whether an error should be thrown if there is no context value.
 */
function useCatalogCategorySectionContext(strict: boolean): CatalogCategorySectionContext | undefined {
  const context = useContext();

  if (strict && !context) {
    throw new Error('useCatalogCategorySectionContext() should be called within a <CatalogCategorySectionProvider />');
  }

  return context;
}

export {
  /**
   * This context provides direct access to the nearest Category ancestor.
   */
  CatalogCategorySectionProvider,
  useCatalogCategorySectionContext,
};
